export default __webpack_public_path__ + "static/media/deal-6.d0eb7f08.webp";